"use client";

import { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";
import { scrollFx } from "@/modules/visual/scrollFx";
import StatsGlance from "./StatsAtGlance";

const StatsGlanceSectionHome: FunctionComponent = () => {
  return (
    <div {...scrollFx({ trigger: "middle", effect: "fade" })}>
      <StatsGlance
        eyebrow={
          <FormattedMessage
            id="home.stats.eyebrow"
            defaultMessage="DESIGNED FOR E-COMMERCE TEAMS"
          />
        }
        title={
          <FormattedMessage
            id="home.stats.title"
            defaultMessage="ChatSystem at a glance"
          />
        }
        subtitle={
          <FormattedMessage
            id="home.stats.subtitle"
            defaultMessage="Des résultats mesurables sur l’accompagnement client et la conversion, là où ça compte : sur vos pages produits."
          />
        }
        stats={[
          {
            value: "+15%",
            label: (
              <FormattedMessage
                id="home.stats.s1"
                defaultMessage="revenu incrémental"
              />
            ),
          },
          {
            value: "2×",
            label: (
              <FormattedMessage
                id="home.stats.s2"
                defaultMessage="conversion sur discussions assistées"
              />
            ),
          },
          {
            value: "100%",
            label: (
              <FormattedMessage
                id="home.stats.s3"
                defaultMessage="process de conseil automatisé"
              />
            ),
          },
          {
            value: "24/7",
            label: (
              <FormattedMessage
                id="home.stats.s4"
                defaultMessage="disponible pour vos clients"
              />
            ),
          },
        ]}
        footnote={
          <FormattedMessage
            id="home.stats.footnote"
            defaultMessage="Chiffres indicatifs basés sur des déploiements et tests pilotes. Les résultats varient selon le catalogue et le trafic."
          />
        }
      />
    </div>
  );
};

export default StatsGlanceSectionHome;
